<template>
	<div class="page-content">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item><span style="cursor: pointer;" @click="gotoSetting">系统设置</span></el-breadcrumb-item>
			<el-breadcrumb-item v-if="$route.query.flowId == 2">违规处理流程设置</el-breadcrumb-item>
			<el-breadcrumb-item v-if="$route.query.flowId == 1"
				:to="{ path: '/activityFlow' }">活动审批流程设置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					客服违规审核范围选择
				</div>
			</el-col>
		</el-row>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;background: white;padding: 20px;display: flex;">
				勾选的角色提交违规举报需要审核
				<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange"
					style="margin-left: 40px;">
					<el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
				</el-checkbox-group>
			</el-col>
		</el-row>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					客户违规审核范围选择
				</div>
			</el-col>
		</el-row>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;background: white;padding: 20px;display: flex;">
				勾选的角色提交违规举报需要审核
				<el-checkbox-group v-model="checkedCities2" @change="handleCheckedCitiesChange2"
					style="margin-left: 40px;">
					<el-checkbox v-for="city in cities2" :label="city" :key="city">{{ city }}</el-checkbox>
				</el-checkbox-group>
			</el-col>
		</el-row>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					违规举报字段配置
				</div>
			</el-col>
		</el-row>
		<el-row v-if="$route.query.flowId == 2">
			<el-col :span="24" style="margin-bottom: 20px;background: white;padding: 20px;display: flex;">
				勾选字段为必填字段
				<el-checkbox-group v-model="checkedFont" @change="updateRequired" style="margin-left: 40px;">
					<el-checkbox v-for="city in fontData" :label="city" :key="city">{{ city }}</el-checkbox>
				</el-checkbox-group>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" style="margin-bottom: 20px;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					流程设置方式选择
				</div>
			</el-col>
		</el-row>
		<div style="margin-bottom: 20px;">
			<FlowDialog :flowId="$route.query.flowId" @on-close="onCloseApprovalDialog" @flowDel="flowDelChange"
				ref="childFlowDialog" />
		</div>
		<el-row>
			<el-col :span="24" style="margin-bottom: 20px;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					流程设置
				</div>
			</el-col>
		</el-row>
		<!-- 页面主体 -->
		<div class="page-main">
			<div style="float: left;overflow: hidden;width: 100%;margin-bottom: 16px;" v-if="$route.query.flowId != 2">
				<div style="margin-right: 20px;" :class="process1 == '1' ? 'changeLcSet' : 'lcSet'"
					@click="clickProcess(0)">
					<div class="lcFont">
						固定流程
					</div>
					<div style="font-size: 12px;">
						设置好固定的审批流程，审批进程按照固定的审批流程进行。
					</div>
				</div>
				<div :class="process2 == '1' ? 'changeLcSet' : 'lcSet'" @click="clickProcess(1)">
					<div class="lcFont">
						可变流程
					</div>
					<div style="font-size: 12px;">
						只设置一级审批人和抄送人，审批人根据审批内容，判断是否添加下级审批人，依次审批。
					</div>
				</div>
			</div>

			<div>
				<span>{{ optionsObj.pageTitle }}</span>
				<!-- <i @click="deleteTemplateDialog = true" class="el-icon-edit-outline changSetting"></i> -->
			</div>
			<el-dialog class="delete-dialog" title="提示" :visible.sync="deleteTemplateDialog" width="320px">
				<div class="g-center">
					<i class="el-icon-warning" style="color: #FFAD34;font-size: 30px"></i>
					<p style="margin-left:10px">切换设置方式将清除当前已设置的流程，确认要切换吗？</p>
				</div>
				<span slot="footer">
					<el-button size="small" class="g-confirm-btn" @click="onDeleteTemplate">确 定</el-button>
					<el-button size="small" class="g-cancel-btn" @click="deleteTemplate">取 消</el-button>
				</span>
			</el-dialog>

			<div class="approval-process">
				<!-- 流程节点 -->
				<div class="approval-process-item-wrapper">
					<div class="approval-process-item">
						<div class="approval-process-begin-end-box">
							{{ $route.query.flowId == 2 ? '违规信息' : '发起活动' }}
						</div>
					</div>
					<div class="approval-process-middle-line">
					</div>
				</div>
				<!-- 流程节点 -->
				<div class="approval-process-item-wrapper">
					<div class="approval-process-item">
						<div class="approval-process-begin-end-box"
							style="border: 0px;background-color: #CFA872;color: #fff;border-radius: 3px;"
							@click="drawChange">
							{{ optionsObj.optionsBtnTitle }}
						</div>
						<approvalDraw ref="drawChild" :data="approvalOptions" :selectIds="getAllSelectIds()"
							:isTotalOptions="true" :title="optionsObj.optionsTitle"
							@on-commit="onApprovalOptionsConform">
						</approvalDraw>
						<!-- 添加平台popover -->
					</div>
					<div class="approval-process-middle-line"></div>
				</div>
				<!-- 流程分支 -->
				<div v-if="getApprovalTempletList.length !== 0" class="approval-process-branch-total">
					<div class="approval-process-branch">
						<div class="approval-process-branch-wrapper">
							<!-- 遍历流程主支 -->
							<div v-for="(singleList, index) in getApprovalTempletList" :key="index"
								class="approval-process-branch-item">
								<div class="approval-process-branch-item-content-box">
									<div v-if="index == 0" class="approval-process-branch-top-left-line"></div>
									<div v-if="index == 0" class="approval-process-branch-bottom-left-line"></div>
									<div v-if="index + 1 == getApprovalTempletList.length"
										class="approval-process-branch-top-right-line"></div>
									<div v-if="index + 1 == getApprovalTempletList.length"
										class="approval-process-branch-bottom-right-line"></div>
									<div class="approval-process-branch-item-content">
										<!-- 遍历流程分支 -->
										<div v-for="(item, ii) in singleList" :key="ii">

											<div v-if="ii == 0" class="approval-process-branch-item-content-plat">
												{{ optionsObj.newName }}
												<div style="background: white;color: #7B7B7B;min-height: 100px;">
													<el-popover v-model="branchPop['pop' + index]" placement="top-end"
														trigger="click">
														<div style="margin-top: -10px">
															<p>确认将此分支删除?</p>
															<div>
																<el-button size="small" class="g-confirm-btn"
																	@click="onDeleteBranch(index)">确定</el-button>
																<el-button size="small" class="g-cancel-btn"
																	@click="branchPop['pop' + index] = false">取消</el-button>
															</div>
														</div>
														<div slot="reference">
															<i class="el-icon-error delete-btn"></i>
														</div>
													</el-popover>
													<approvalDraw ref="drawChild2" :title="optionsObj.optionsTitle"
														:data="approvalOptions" :selectIds="item.foreignid"
														@on-commit="(data) => onApprovalOptionsConform(data, true, index)">
													</approvalDraw>
													<div @click="drawChange2">
														<div v-if="getOptionsNamesByTemplate(item).length == 1">
															{{ getOptionsNamesByTemplate(item)[0] }}
														</div>
														<el-row v-else :gutter="10">
															<el-col
																style="white-space: nowrap;overflow: hidden;text-align: center;"
																v-for="(name, kk) in getOptionsNamesByTemplate(item)"
																:key="kk" :span="12">
																{{ name }}
															</el-col>
														</el-row>
													</div>
												</div>
											</div>
											<div v-if="ii !== 0" class="approval-process-branch-item-content-plat">
												{{ newChildId !== '1' ? item.cc ? '抄送人' : '审批人' : '处理人' }}
												<!-- <div :style="item.cc ? 'background-color: #FAAD14;border: none;color: #fff' : 'background-color: #0084F2;color: #fff'" class="approval-process-add-approval-btn"> -->
												<div
													style="background: white;color: #7B7B7B;min-height: 100px;padding-top: 10px;">
													<div class="g-column-center"
														@click="changeTree(1, index, item.cc, ii, item)">
														<!-- <span>{{ newChildId !== '1' ? item.cc ? '抄送人' : '审批人' : '处理人' }}</span> -->
														<div class="g-column-center" v-if="item.cc">
															<span v-for="(id, key) in item.cc.split(',')" :key="key">
																{{ getApprovalPersonNameById(id) }}
															</span>
														</div>
														<div v-else>
															<div v-if="item.approvaluseid.split(',').length < 6">
																<div v-for="(id, key) in item.approvaluseid.split(',')"
																	:key="key" class="g-center">
																	<span>
																		{{ getApprovalPersonNameById(id) }}
																	</span>
																</div>
															</div>
															<el-row v-if="item.approvaluseid.split(',').length >= 6">
																<el-col class="g-center"
																	v-for="(id, key) in item.approvaluseid.split(',')"
																	:key="key" :span="12">
																	{{ getApprovalPersonNameById(id) }}
																</el-col>
															</el-row>
														</div>
													</div>
													<el-popover v-model="deletePop['pop' + index + ii]"
														placement="top-end" trigger="click">
														<div style="margin-top: -10px">
															<p>确认将此{{ newChildId !== '1' ? item.cc ? '抄送人' : '审批人' :
																'处理人' }}删除?</p>
															<div>
																<el-button size="small" class="g-confirm-btn"
																	@click="onDeleteApprovalPerson(item, index, ii)">确定</el-button>
																<el-button size="small" class="g-cancel-btn"
																	@click="deletePop['pop' + index + ii] = false">取消</el-button>
															</div>
														</div>
														<div slot="reference">
															<i class="el-icon-error delete-btn"></i>
														</div>
													</el-popover>
												</div>
												</el-popover>
											</div>
										</div>

										<div v-show="singleList.length == 1" style="margin-top: 0"
											class="approval-process-branch-item-content-person">
											<div class="approval-process-begin-end-box"
												style="border: 0px;background-color: #CFA872;color: #fff;border-radius: 3px;margin-top: 75px;cursor: pointer;"
												@click="changeTree(2, index, true, singleList.length)">
												{{ newChildId !== '1' ? "添加审批人" : "添加处理人" }}
											</div>
										</div>
										<div v-if="singleList.length > 1 && !singleList[singleList.length - 1].cc && newChildId !== '1'"
											class="approval-process-branch-item-content-add">
											<el-popover v-model="addPopover['pop' + index]" placement="bottom"
												trigger="click">
												<el-row :gutter="10">
													<el-col :span="12">
														<div class="approval-process-add-approval-btn"
															@click="changeTree(3, index, true, singleList.length)">
															添加审批人
														</div>
													</el-col>
													<el-col :span="12">
														<div class="approval-process-add-copy-btn"
															@click="changeTree(4, index, false, 0)">
															添加抄送人
														</div>
													</el-col>
												</el-row>
												<i slot="reference" class="el-icon-circle-plus-outline approval-add-btn"
													v-if="$route.query.flowId != 2 && singleList.length == 0 || $route.query.flowId == 1"></i>
											</el-popover>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="approval-process-middle-line"></div>
					</div>
				</div>
				<!-- 流程节点 -->
				<div class="approval-process-item-wrapper">
					<div class="approval-process-item">
						<div class="approval-process-begin-end-box">
							结束
						</div>
					</div>
				</div>
			</div>
		</div>
		<drawTree ref="drawTreeChild" :data="getActivityPerson" :defaultProps="defaultProps" :title="newTitile"
			:isApproval="isApprovalShow" :index="dataIndex" :ii="dataIi"
			@up-approval="(data) => onUpdateApprovalPerson(data, this.dataItem)"
			@add-approval="(data) => onAddApprovalPerson(data, dataIndex, true)">
		</drawTree>
	</div>
</template>

<script>
import ApprovalTree from '@/components/approvalTree/approvalTree.vue'
import drawTree from '@/components/approvalTree/drawTree.vue'
import ApprovalOptions from '@/components/approvalOptions/approvalOptions.vue'
import approvalDraw from '@/components/approvalOptions/approvalDraw.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import FlowDialog from './flowDialog'
export default {
	name: 'activityApprovalSetting',

	components: {
		ApprovalTree,
		ApprovalOptions,
		approvalDraw,
		drawTree,
		FlowDialog
	},
	data() {
		return {
			dataIndex: 0,
			isApprovalShow: false,
			newTitile: '',
			dataIi: 0,
			dataItem: [],
			checkedCities: [],
			checkedCities2: [],
			cities: ['客服'],
			cities2: ['客户'],
			checkedFont: [],
			fontData: ['举证材料'],
			process1: '1',
			process2: '2',
			processmodel: 0,
			newChildId: '',
			extraVisible: true,
			deleteTemplateDialog: false,
			addPopover: {},
			branchPop: {},
			deletePop: {},
			mainid: 0,
			approvalMethedId: 0,
			defaultProps: {
				children: 'children',
				label: 'title',
			},
			updateApprovalTempletId: '',
			refList: []
		}
	},

	methods: {
		// 查询状态
		selectbmcCampaigntype() {
			fetch({
				url: "hcm/cus/selectbmcSetting",
				method: "get",
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					if (res.data.reportKefuAuditing == 0) {
						this.checkedCities = []
					} else {
						this.checkedCities = ['客服']
					}
					if (res.data.reportBrmAuditing == 0) {
						this.checkedCities2 = []
					} else {
						this.checkedCities2 = ['客户']
					}
					if (res.data.reportRequiredField == 'reportpic') {
						this.checkedFont = ['举证材料']
					} else {
						this.checkedFont = []
					}
				} else {
					this.$message.error(res.message)
				}
			})
		},
		updateRequired() {
			let params = {}
			if (this.checkedFont.length > 0) {
				params.fieldName = 'reportpic'
			} else {
				params.fieldName = ''
			}
			fetch({
				url: "/hcm/cus/updateReportFieldRequired",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.selectbmcCampaigntype()
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			})
		},
		handleCheckedCitiesChange() {
			let reportKefuAuditing
			if (this.checkedCities.length > 0) {
				reportKefuAuditing = 1
			} else {
				reportKefuAuditing = 0
			}
			let params = {
				reportKefuAuditing: reportKefuAuditing,
			}
			fetch({
				url: "/hcm/cus/updateReportKefuAuditingbrm",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.selectbmcCampaigntype()
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			})
		},
		handleCheckedCitiesChange2() {
			let reportBrmAuditing
			if (this.checkedCities2.length > 0) {
				reportBrmAuditing = 1
			} else {
				reportBrmAuditing = 0
			}
			let params = {
				reportBrmAuditing: reportBrmAuditing,
			}
			fetch({
				url: "/hcm/cus/updateReportBrmAuditing",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.selectbmcCampaigntype()
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			})
		},
		drawTreeChild(el) {
			this.refList.push(el)
		},
		changeTree(e, index, cc, ii, item) {
			if (e == 1) {
				this.dataIndex = index
				this.isApprovalShow = cc ? false : true
				this.newTitile = this.newChildId !== '1' ? cc ? '抄送人' : '审批人' : '处理人'
				this.dataIi = ii
				this.dataItem = item
			} else if (e == 2) {
				this.dataIndex = index
				this.isApprovalShow = cc
				this.newTitile = this.newChildId !== "1" ? "添加审批人" : "添加处理人"
				this.dataIi = ii
			} else if (e == 3) {
				this.dataIndex = index
				this.isApprovalShow = cc
				this.newTitile = "添加审批人"
				this.dataIi = ii
			} else if (e == 4) {
				this.dataIndex = index
				this.isApprovalShow = cc
				this.newTitile = "添加抄送人"
				this.dataIi = ii
			}
			this.$refs.drawTreeChild.popoverVisible = true
		},
		drawChange() {
			this.$refs.drawChild.drawShow()
		},
		drawChange2() {
			this.$refs.drawChild2[0].visible = true
		},
		clickProcess(e) {
			if (e == 0) {
				this.process1 = '1'
				this.process2 = '2'
				this.processmodel = 0
			} else {
				this.process1 = '2'
				this.process2 = '1'
				this.processmodel = 1
			}
			this.updateApprovalTemplet()
		},
		updateApprovalTemplet() {
			let params = {
				id: this.updateApprovalTempletId,
				processmodel: this.processmodel,
			}
			fetch({
				url: "hcm/hcmApproval/updateApprovalTemplet",
				method: "post",
				data: params,
				noFormat: true,
				responseType: "text",
				timeout: 60 * 1000 * 5
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					window.location.reload()
				} else {
					this.$message.error(res.message);
				}
			}).catch(err => {
				this.$message.error('接口异常');
			});

		},
		flowDelChange() {
			this.deleteTemplateDialog = true
		},
		async onCloseApprovalDialog(id) {
			this.newChildId = id
			await this.reqActivityPeople();
			this.load();
		},
		gotoSetting() {
			this.$router.push('/systemSetupList/systemSetup');
		},
		async onDeleteTemplate() {
			this.reqDeleteApprovalTemplate({
				id: this.mainid
			}).then(res => {
				if (res.status == '10000') {
					let data = {
						index: '',
						flowId: this.$route.query.flowId
					}
					this.$refs.childFlowDialog.childFlow(data)
					this.$message.success('删除模板成功');
					this.deleteTemplateDialog = false
					window.location.reload()
				}
			})
		},
		deleteTemplate() {
			let data = {
				index: this.newChildId - 1,
				flowId: this.$route.query.flowId
			}
			this.$refs.childFlowDialog.childFlow(data)
			this.deleteTemplateDialog = false
		},
		async onUpdateApprovalPerson(data, item) {
			let updateData = {
				id: item.id,
				approvaluseid: data.isApproval ? data.id.join(',') : null,
				cc: data.isApproval ? null : data.id.join(',')
			}
			// data.isApproval ? updateData.approvaluseid = data.id.join(',') : updateData.cc = data.id.join(',');

			const res = await this.reqUpdateApprovalPerson(updateData)
			if (res.status == '10000') {
				this.$message.success('更新节点成功');
				data.cb();
				await this.loadTemplate();
				this.findApprovalTreeComAndReflesh();
			}
		},
		onDeleteBranch(index) {
			if (this.getApprovalTempletList[index][0].isTemporary) {
				this.$store.commit('deleteApprovalBranch', index);
				this.loadOptions();
			} else {
				this.reqDeleteBranch({
					foreignid: this.getApprovalTempletList[index][0].foreignid
				}).then(res => {
					this.$message.success('删除分支成功');
					this.loadTemplate();
					this.loadOptions();
				})
			}
			this.branchPop['pop' + index] = false;
		},
		getAllSelectIds() {
			let res = '';
			this.getApprovalTempletList.forEach(arr => {
				res = res ? res + ',' + arr[0].foreignid : res + arr[0].foreignid
			})
			return res;
		},
		async onDeleteApprovalPerson(item, index, ii) {
			const res = await this.reqDeleteApprovalPerson({
				childid: item.id
			})
			if (res.status == '10000') {
				this.$message.success('删除节点成功');
				await this.loadTemplate();
				this.loadOptions();
				this.deletePop['pop' + index + ii] = false;
				this.findApprovalTreeComAndReflesh();
			}
		},
		findApprovalTreeComAndReflesh() {
			this.extraVisible = false;
			this.$children.forEach(child => {
				if (child.$options.name == 'approvalTree') {
					child.refleshSelectAndDisableData();
				}
			})
			setTimeout(() => {
				this.extraVisible = true;
			}, 1);
		},
		getApprovalPersonNameById(id) {
			let name;
			function loop(data) {
				for (let i of data) {
					if (i.value == id) {
						name = i.title
					}
					if (i.children && i.children.length > 0) {
						loop(i.children);
					} else {
						continue;
					}
				}
			}
			loop(this.getActivityPerson)
			return name
		},
		getOptionsNamesByTemplate(item) {
			let res = [];
			let foreignid = item.foreignid;

			let foreignidArr = foreignid.split(",");
			for (let id of foreignidArr) {
				for (let item of this.approvalOptions) {
					if (id == item.id) {
						res.push(item.name);
					}
				}
			}
			return res;
		},
		async onAddApprovalPerson(data, index, isFirstAdd) {
			let singleList = this.getApprovalTempletList[index];
			let addData = {
				foreignid: singleList[0].foreignid,
				mainid: this.mainid,
				lastnode: isFirstAdd ? 0 : singleList[singleList.length - 1].id
			}
			if (data.isApproval) {
				addData['approvaluseid'] = data.id.join(',');
			} else {
				addData['cc'] = data.id.join(',');
			}
			const res = await this.reqAddApprovalPerson(addData)
			if (res.status == '10000') {
				this.$message.success('添加节点成功');
				data.cb();
				this.addPopover['pop' + index] = false;
				// 删除临时分支
				if (this.getApprovalTempletList[index][0].isTemporary) {
					this.onDeleteBranch(index);
				}
				if (isFirstAdd) {
					this.loadOptions();
				}
				await this.loadTemplate();
				this.findApprovalTreeComAndReflesh();
			}
		},
		getOptionNames(data) {
			let optionNames = [];
			for (let item of this.approvalOptions) {
				for (let id of data) {
					if (item.id == id) {
						optionNames.push(item.name);
					}
				}
			}
			return optionNames;
		},
		onApprovalOptionsConform(data, isUpdate, index) {
			if (data.id.length == 0) {
				this.$message.error('请选择选项');
				return;
			}
			let optionNames = this.getOptionNames(data.id);
			if (isUpdate) {
				if (this.getApprovalTempletList[index][0].isTemporary) {
					this.$message.error('此为临时分支，请添加审批人后再选择更改选项');
					return;
				}
				this.reqChangeForeign({
					mainid: this.mainid,
					oldforeign: this.getApprovalTempletList[index][0].foreignid,
					foreign: data.id.join(","),
				}).then(res => {
					if (res.status == '10000') {
						this.$message.success('更改选项成功');
						this.loadTemplate();
						this.loadOptions();
						data.cb();
					}
				})
			} else {
				this.$store.commit('addApprovalBranch', {
					optionNames,
					foreignid: data.id.join(","),
					isTemporary: true
				})
				data.cb();
				this.loadOptions();
			}
		},
		...mapActions([
			'reqDeleteApprovalTemplate',
			'reqChangeForeign',
			'reqApprovalTemplate',
			'reqApprovalOptions',
			'reqActivityPeople',
			'reqAddApprovalPerson',
			'reqDeleteApprovalPerson',
			'reqDeleteBranch',
			'reqUpdateApprovalPerson'
		]),
		loadTemplate() {
			let newType
			if (this.$route.query.flowId == 2 || this.$route.query.flowId == '2') {
				newType = 'REP'
			} else {
				newType = 'CAM'
			}
			let declaremeans
			if (this.$route.query.flowId == 2 || this.$route.query.flowId == '2') {
				declaremeans = ''
			} else if (this.$route.query.id == '2') {
				declaremeans = '0'
			} else if (this.$route.query.id == '3') {
				declaremeans = '1'
			} else {
				declaremeans = '2'
			}

			return new Promise(r => {
				this.reqApprovalTemplate({
					type: newType,
					declaremeans: declaremeans
				}).then(res => {
					if (res.id) {
						this.updateApprovalTempletId = res.id
					}
					if (res.processmodel) {
						if (res.processmodel == 0) {
							this.process1 = '1'
							this.process2 = '2'
							this.processmodel = 0
							console.log('固定流程')
						} else {
							this.process1 = '2'
							this.process2 = '1'
							this.processmodel = 1
							console.log('可变流程')
						}
					}

					if (res.approvalmethed) {
						if (this.$route.query.approvalWay == 'campaignlink' || this.$route.query.approvalWay == 'campaignshop') {
							this.approvalMethedId = res.approvalmethed - 1
						} else {
							this.approvalMethedId = res.approvalmethed
						}
						this.newChildId = this.approvalMethedId
					}
					let data = {
						index: this.newChildId - 1,
						flowId: this.$route.query.flowId
					}
					if (this.$route.query.approvalWay) {
						data.approvalWay = this.$route.query.approvalWay
					}
					this.$refs.childFlowDialog.childFlow(data)

					this.mainid = res.id
					r()
				})
			})

		},
		loadOptions() {
			let id;
			if (this.$route.query.flowId == 1) {
				if (this.$route.query.approvalWay == 'campaignproduct') {
					id = parseInt(this.approvalMethedId);
				} else if (this.approvalMethedId) {
					id = parseInt(this.approvalMethedId) + 1;
				}
			} else {
				id = parseInt(this.approvalMethedId);
			}
			this.reqApprovalOptions({
				approvalmethed: id,
				mainid: this.mainid
			}).then(() => {
				this.$store.commit('updateOptions')
			})
		},
		loopPeople(data, ids) {
			for (let id of ids) {
				for (let i of data) {
					if (i.value == id) {
						i.isSelected = true;
					}
					if (i.children && i.children.length > 0) {
						this.loopPeople(i.children, ids);
					} else {
						continue;
					}
				}
			}
		},
		load() {
			this.loadTemplate().then(() => {
				this.loadOptions();
			});
		}
	},

	computed: {
		getApprovalPeople() {
			let res = [];
			let list = this.getApprovalTempletList;
			for (let branch of list) {
				// 分支中被选择的审批人
				let ids = [];
				// 数据源
				let source = _.cloneDeep(this.getActivityPerson);
				for (let node of branch) {
					ids.push(node.approvaluseid);
				}
				this.loopPeople(source, ids)
				res.push(source);
			}
			this.$forceUpdate();
			return res;
		},
		optionsObj() {
			let id;
			if (this.$route.query.flowId == 1) {
				if (this.$route.query.approvalWay == 'campaignproduct') {
					id = parseInt(this.approvalMethedId);
				} else if (this.approvalMethedId) {
					id = parseInt(this.approvalMethedId) + 1;
				}
			} else {
				id = parseInt(this.approvalMethedId);
			}
			if (id == 1) {
				return {
					optionsTitle: "产品所属品类",
					optionsBtnTitle: "添加品类",
					newName: "品类",
					pageTitle: this.$route.query.flowId == 2 ? "按产品所属售价表分类设置" : "按产品所属品类审批"
				}
			}
			if (id == 2) {
				return {
					optionsTitle: "店铺所属部门",
					optionsBtnTitle: "添加部门",
					newName: "部门",
					pageTitle: this.$route.query.flowId == 2 ? "按店铺所属部门设置" : "按店铺所属部门审批"
				}
			}
			if (id == 3) {
				return {
					optionsTitle: "店铺所属平台",
					optionsBtnTitle: "添加平台",
					newName: "平台",
					pageTitle: this.$route.query.flowId == 2 ? "按店铺所属平台设置" : "按店铺所属平台审批"
				}
			}
			if (id == 4) {
				return {
					optionsTitle: "店铺名称",
					optionsBtnTitle: "添加店铺",
					newName: "店铺",
					pageTitle: this.$route.query.flowId == 2 ? "按店铺设置" : "按店铺审批"

				}
			}
			return {
				optionsTitle: "",
				optionsBtnTitle: "",
				pageTitle: "",
				newName: ""
			}
		},
		...mapGetters([
			'getActivityPerson',
			'getApprovalTempletList'
		]),
		...mapState({
			approvalOptions: state => state.approvalSetting.approvalOptions,
		}),
	},

	beforeDestroy() {
		this.$store.commit('deleteAllApprovalBranch');
	},


	async created() {
		this.newChildId = this.$route.query.id
		this.selectbmcCampaigntype()
		await this.reqActivityPeople();
		this.load();
	},

	mounted() {
		let data = {
			flowId: this.$route.query.flowId
		}
		if (this.$route.query.approvalWay) {
			data.approvalWay = this.$route.query.approvalWay
		}
		this.$refs.childFlowDialog.childFlow(data)

	},
}
</script>


<style lang='scss'>
.delete-dialog {
	display: flex;
	justify-content: center;
	align-items: center;

	.el-dialog {
		margin: auto !important;
	}
}

.lcSet {
	float: left;
	width: 40%;
	border: 1px solid #999;
	border-radius: 10px;
	min-height: 20px;
	color: #666666;
	font-size: 18px;
	cursor: pointer;
	padding: 20px;
}

.lcSet:hover {
	border: 1px solid #2997ff;
}

.changeLcSet {
	float: left;
	width: 40%;
	border: 1px solid #2997ff;
	border-radius: 10px;
	min-height: 20px;
	color: #2997ff;
	font-size: 18px;
	cursor: pointer;
	padding: 20px;
}

.lcFont {
	font-weight: 600;
	margin-bottom: 8px;
}

.lcFont:hover {
	color: #2997ff;
}

@import '@/style/activityApprovalSetting.scss'
</style>
